import React from "react";

const VideoPreview = ({ videoPreviewURL, isLink, getYouTubeEmbedUrl }) => {
  if (!videoPreviewURL) return null;

  return (
    <div style={{ marginTop: 16 }}>
      {isLink ? (
        <iframe
          width="100%"
          height="240"
          src={getYouTubeEmbedUrl(videoPreviewURL)}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="video-preview"
        />
      ) : (
        <video width="100%" height="240" controls src={videoPreviewURL}>
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default VideoPreview;
